import { render } from "./RoleListItem.vue?vue&type=template&id=3dbc766f&scoped=true"
import script from "./RoleListItem.vue?vue&type=script&lang=js"
export * from "./RoleListItem.vue?vue&type=script&lang=js"

import "./RoleListItem.vue?vue&type=style&index=0&id=3dbc766f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbc766f"]])

export default __exports__